import React from 'react';
import Styles from "./join.module.css";

export function Join() {
    

    return (
        <div className={Styles.join}>
            <h2>
                Join us in making<br />
                <span className={Styles.sustainable}>sustainable</span>
                shopping effortless
            </h2>
        </div>
    );
}
